import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import useTranslation from 'next-translate/useTranslation';

import Axios from '@/utils/axios';
import newsFilter from '@/constants/newsFilter';
import { CLIENT_URL } from '@/constants/index';
import { SectionTitle, Select, Pagination, ScreenLoader } from '@/ui/index';

import { NewsItem } from '../../common';

import styles from './NewsList.module.scss';

const newsFilterData = newsFilter();
const fetcher = (url, { queryParams = '', lang }) =>
  Axios.get(`${url}${queryParams}`, {
    headers: {
      'Accept-Language': lang,
    },
    baseURL: CLIENT_URL,
  }).then((res) => res.data);

const limit = 9;
const defaultQuery = `?per_page=${limit}&`;

const NewsList = ({ title = '' }) => {
  const { t, lang } = useTranslation();
  const router = useRouter();
  const [queryParams, setQueryParams] = useState();
  const [page, setPage] = useState(1);
  const { data } = useSWR(
    [`/news/${defaultQuery}`, { queryParams, lang }],
    fetcher,
  );
  const [month, setMonth] = useState(
    newsFilterData[0].options.find((el) => el.value === router.query.month) ||
      newsFilterData[0].options[0],
  );
  const [year, setYear] = useState(
    newsFilterData[1].options.find((el) => el.value === router.query.year) ||
      newsFilterData[1].options[0],
  );
  const onChangeHandlerMonth = (value, callback) => {
    router.push(
      {
        query: {
          ...router.query,
          page: 1,
          month: value.value,
        },
      },
      undefined,
      { shallow: true },
    );
    callback(value);
  };
  const onChangeHandlerYear = (value, callback) => {
    router.push(
      {
        query: {
          ...router.query,
          page: 1,
          year: value.value,
        },
      },
      undefined,
      { shallow: true },
    );
    callback(value);
  };

  useEffect(() => {
    const query = {
      page,
      year: year.value,
      month: month.value,
    };
    setQueryParams(new URLSearchParams(query).toString());
  }, [page, year.value, month.value]);

  useEffect(() => {
    if (!router.isReady) return;
    setPage(router.query.page || 1);
  }, [router.query.page, router.isReady]);
  return (
    <>
      {!data && <ScreenLoader visible />}
      <div
        className='wrapper section'
        itemScope
        itemType='https://schema.org/NewsArticle'
      >
        <div className={styles.titleWrapper}>
          <SectionTitle className={styles.title} titleModify={'title--large'}>
            {title}
          </SectionTitle>
          <div className={styles.filters}>
            <Select
              value={month}
              data={newsFilterData[0].options}
              label={t('common:month')}
              onChange={(value) => onChangeHandlerMonth(value, setMonth)}
            />
            <Select
              value={year}
              data={newsFilterData[1].options}
              label={t('common:year')}
              onChange={(value) => onChangeHandlerYear(value, setYear)}
            />
          </div>
        </div>
        {data?.news?.length > 0 ? (
          <div className={`grid-extend equal ${styles.list}`}>
            {data?.news?.map((item, key) => (
              <NewsItem data={item} key={key} />
            ))}
          </div>
        ) : (
          <div>{t('common:noNews')}</div>
        )}
        {data?.news_count > limit && (
          <Pagination perpage={limit} total={data?.news_count} />
        )}
      </div>
    </>
  );
};

export default NewsList;
